module.exports = __webpack_public_path__ + "static/img/logo.86ac0f53.jpg";